class PbcShop extends HTMLElement {
  connectedCallback() {
    this.events?.abort();
    this.events = new AbortController();
    const options = { signal: this.events.signal };
    this.addEventListener('click', (event) => {
      const link = event.target.closest('a[data-shop-link]');
      if (!link || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
      event.preventDefault();
      const url = new URL(link.href);
      const sort = new URL(location.href).searchParams.get('sort_by');
      if (sort && !url.searchParams.has('sort_by')) url.searchParams.set('sort_by', sort);
      this.load(url, true, link.closest('.pbc-shop__pagination') ? 'grid' : 'chip');
    }, options);
    this.addEventListener('change', (event) => {
      if (!event.target.matches('[name="sort_by"]')) return;
      const url = new URL(event.target.closest('form').action);
      url.searchParams.set('sort_by', event.target.value);
      url.searchParams.delete('page');
      this.load(url, true, 'sort');
    }, options);
    window.addEventListener('popstate', () => this.load(new URL(location.href), false), options);
  }
  disconnectedCallback() { this.events?.abort(); this.request?.abort(); }
  async load(url, push, focus) {
    if (url.origin !== location.origin) return;
    url.searchParams.set('view', this.dataset.view || 'pbc-shop');
    this.request?.abort();
    const request = this.request = new AbortController();
    this.setAttribute('aria-busy', 'true');
    this.querySelector('[data-shop-error]').hidden = true;
    try {
      const response = await fetch(url, {signal:request.signal});
      if (!response.ok) throw new Error('Unable to load collection');
      const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
      const content = doc.querySelector('pbc-shop [data-shop-content]');
      if (!content || request.signal.aborted) throw new Error('Missing collection');
      const chipScroll = this.querySelector('.pbc-shop__chips').scrollLeft;
      this.querySelector('[data-shop-content]').replaceWith(content);
      this.querySelector('.pbc-shop__chips').scrollLeft = chipScroll;
      if (push) history.pushState({}, '', url);
      document.title = doc.title;
      this.querySelector('[data-shop-status]').textContent = this.querySelector('[data-shop-count]').textContent;
      const target = focus === 'sort' ? this.querySelector('[name="sort_by"]') : focus === 'chip' ? this.querySelector('[aria-current]') : focus === 'grid' ? this.querySelector('#PbcShopGrid') : null;
      target?.focus({preventScroll: true});
      if (focus === 'grid') target.scrollIntoView({block:'start', behavior:'instant'});
    } catch(error) {
      if (request.signal.aborted) return;
      this.querySelector('[data-shop-error]').hidden = false;
      this.querySelector('[data-shop-retry]').href = url;
    } finally {
      if (this.request === request) this.removeAttribute('aria-busy');
    }
  }
}
if (!customElements.get('pbc-shop')) customElements.define('pbc-shop', PbcShop);
